"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function chatExtraInfoController() {
    //const
    var vm = this;

    //vars
    vm.observerConfig = { attributes: false, childList: true };
    vm.isExtraInfoPresent = false;
    vm.element = null;
    vm.observer = null;

    var observerCallback = function observerCallback() {
        vm.checkExtraInfoPresent();
    };

    vm.setElement = function (element) {
        vm.element = element;
    };

    vm.setExtraInfoPresent = function (isPresent) {
        vm.isExtraInfoPresent = isPresent;
    };

    vm.init = function () {
        if (window.MutationObserver) {
            vm.observer = new MutationObserver(observerCallback);
            vm.observer.observe(vm.element, vm.observerConfig);
        }
    };
}

exports.default = chatExtraInfoController;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/chat-extra-info.controller.js
// module id = 868
// module chunks = 0